<template>
  <div id="app2">
    <el-container>
      <!-- header 顶部 -->
      <el-header style="height:50px;padding:0px;">
        <Header></Header>
      </el-header>
      <el-container>
        <!-- aside 侧边栏 -->
        <el-aside width="200px" style="background-color:#283142;overflow: hidden;">
          <Aside></Aside>
        </el-aside>
        <el-container>
          <!-- main 主体显示部分 -->
          <el-main style="overflow:hidden;min-width:1000px;">
            <div class="contaner_box">
              <router-view class="home-container" ref="routerViewer" v-on:loaded="routerViewLoaded" />
            </div>
          </el-main>
          <!-- footer 底部 -->
          <el-footer v-if="false" style="height:40px;background:#fff;text-align:center;font-size:16px;color:#000;line-height:40px;">&copy;版权所有&nbsp;高信达信息科技有限公司</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Header from "./header.vue";
import Aside from "./aside.vue";
import session from "../common/sessionMgr";
export default {
  name: "home",
  data() {
    return {
      isShow: true,
      keyword: "",
      tempKeyword: "",
      userName: session.getUserName()
    };
  },
  components: {
    Header, //顶部header组件
    Aside //左边侧边栏菜单
  },
  methods: {
    //当路由嵌入视图加载完成后触发
    routerViewLoaded(route) {
      //   if (this.$refs.routerViewer.loaded) {
      //     if (route.params && JSON.stringify(route.params) != "{}") {
      //       //alert("5");
      //       route.params.loadingByGlobalQuery = false;
      //       this.$refs.routerViewer.loaded(route.params);
      //     }
      //   }
    },
    logout: function() {
      if (confirm("确定要退出？")) {
        session.logout();
      }
    },

    filterMenuByPermission: function() {
      let removeLiList = [];
      $("ul.menu-1>li>ul.menu-2>li").each(function() {
        let perm = $(this).data("permission");
        if (!session.hasPermission(perm)) {
          //$(this).css("display","none");
          removeLiList.push($(this));
        }
      });
      removeLiList.forEach(function(item) {
        item.remove();
      });

      let removeUlList = [];
      $("ul.menu-1>li>ul.menu-2").each(function() {
        if ($(this).children().length == 0) {
          removeUlList.push($(this).parent());
        }
      });
      removeUlList.forEach(function(item) {
        item.remove();
      });
    }
  }
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/Home.vue